<template>
  <div>
    <div class="v-carousel">
      <h2 class="fieldhelp-title">Homepage</h2>
      <v-carousel
        height="500"
        hide-delimiter-background
        show-arrows
        color="black"
      >
        <v-carousel-item v-for="(item, i) in homepages" :key="i">
          <v-sheet color="transparent" height="100%">
            <div class="d-flex fill-height justify-between align-center">
              <div
                class="fill-height d-flex justify-center align-center"
                style="width: 120rem"
              >
                <img
                  :src="`https://ik.imagekit.io/tiuh2lft4/fieldhelp/homepage${
                    i + 1
                  }.png`"
                  alt="Homepage Image"
                  :height="item.height"
                />
              </div>
              <div class="fill-height ml-4 my-5 d-flex justify-end w-50">
                <v-card
                  class="fill-height rounded-0 d-flex"
                  elevation="0"
                  style="overflow: hidden; background-color: transparent"
                >
                  <v-card-text class="v-card-text" style="overflow: auto">
                    <div class="text-h3 mb-4">{{ item.title }}</div>
                    <p class="text-body-1">
                      <span class="font-weight-bold">Description:</span>
                      {{ item.description }}
                    </p>
                    <p class="text-body-1">
                      <span class="font-weight-bold">Functionality:</span>
                      {{ item.functionality }}
                    </p>
                    <p class="text-body-1">
                      <span class="font-weight-bold mr-1">Components:</span>
                      <v-chip
                        v-for="(component, i) in item.components"
                        :key="i"
                        class="mx-1"
                        >{{ component }}</v-chip
                      >
                    </p>
                  </v-card-text>
                </v-card>
              </div>
            </div>
          </v-sheet>
        </v-carousel-item>
      </v-carousel>
    </div>
    <v-divider class=".v-divider"></v-divider>
    <div class="v-carousel">
      <h2 class="fieldhelp-title">Datagrid</h2>
      <v-carousel
        height="500"
        hide-delimiter-background
        show-arrows
        color="black"
      >
        <v-carousel-item v-for="(item, i) in datagrids" :key="i">
          <v-sheet color="transparent" height="100%">
            <div class="d-flex fill-height justify-between align-center">
              <div
                class="fill-height d-flex justify-center align-center"
                style="width: 120rem"
              >
                <img
                  :src="`https://ik.imagekit.io/tiuh2lft4/fieldhelp/datagrid${
                    i + 1
                  }.png`"
                  alt="Datagrid Image"
                  :height="item.height"
                />
              </div>
              <div class="fill-height ml-4 my-5 d-flex justify-end w-50">
                <v-card
                  class="fill-height rounded-0 d-flex"
                  elevation="0"
                  style="overflow: hidden; background-color: transparent"
                >
                  <v-card-text class="v-card-text" style="overflow: auto">
                    <div class="text-h3 mb-4">{{ item.title }}</div>
                    <p class="text-body-1">
                      <span class="font-weight-bold">Description:</span>
                      {{ item.description }}
                    </p>
                    <p class="text-body-1">
                      <span class="font-weight-bold">Functionality:</span>
                      {{ item.functionality }}
                    </p>
                    <p class="text-body-1">
                      <span class="font-weight-bold mr-1">Components:</span>
                      <v-chip
                        v-for="(component, i) in item.components"
                        :key="i"
                        class="mx-1"
                        >{{ component }}</v-chip
                      >
                    </p>
                  </v-card-text>
                </v-card>
              </div>
            </div>
          </v-sheet>
        </v-carousel-item>
      </v-carousel>
    </div>
    <v-divider class=".v-divider"></v-divider>
  </div>
</template>

<script>
import DecodeJWT from "../DecodeJWT";

export default {
  mounted() {
    let token = localStorage.getItem("token");
    if (token == "" || !token) {
      this.$router.push("/login");
    } else {
      var info = DecodeJWT(token);
      if (info.exp <= new Date().getTime() / 1000) {
        this.$router.push("/login");
      }
    }
  },
  data() {
    return {
      colors: [
        "indigo",
        "warning",
        "pink darken-2",
        "red lighten-1",
        "deep-purple accent-4",
      ],
      slides: ["First", "Second", "Third", "Fourth", "Fifth"],
      homepages: [
        {
          title: "Homepage",
          height: "80%",
          description:
            "The homepage is typically the default page displayed when users access your application. It usually contains an overview of the application or important content such as news, greetings, or brief instructions.",
          functionality:
            "The homepage usually doesn't have many complex features but instead displays basic information. Depending on the needs, you can add sections like featured articles, important links, or interesting images.",
          components: ["Card Group", "Service Request"],
        },
        {
          title: "Service Request",
          height: "100%",
          description:
            "The homepage is typically the default page displayed when users access your application. It usually contains an overview of the application or important content such as news, greetings, or brief instructions.",
          functionality:
            "The homepage usually doesn't have many complex features but instead displays basic information. Depending on the needs, you can add sections like featured articles, important links, or interesting images.",
          components: ["Info Textfield", "Submit Button"],
        },
        {
          title: "Card Group",
          height: "100%",
          description:
            "The homepage is typically the default page displayed when users access your application. It usually contains an overview of the application or important content such as news, greetings, or brief instructions.",
          functionality:
            "The homepage usually doesn't have many complex features but instead displays basic information. Depending on the needs, you can add sections like featured articles, important links, or interesting images.",
          components: ["Customer Bar", "Card"],
        },
        {
          title: "Card",
          height: "50%",
          description:
            "The homepage is typically the default page displayed when users access your application. It usually contains an overview of the application or important content such as news, greetings, or brief instructions.",
          functionality:
            "The homepage usually doesn't have many complex features but instead displays basic information. Depending on the needs, you can add sections like featured articles, important links, or interesting images.",
          components: ["Icon", "Label"],
        },
      ],
      datagrids: [
        {
          title: "Datagrid",
          height: "80%",
          description:
            "The homepage is typically the default page displayed when users access your application. It usually contains an overview of the application or important content such as news, greetings, or brief instructions.",
          functionality:
            "The homepage usually doesn't have many complex features but instead displays basic information. Depending on the needs, you can add sections like featured articles, important links, or interesting images.",
          components: ["Header", "Detail"],
        },
        {
          title: "Header",
          height: "60%",
          description:
            "The homepage is typically the default page displayed when users access your application. It usually contains an overview of the application or important content such as news, greetings, or brief instructions.",
          functionality:
            "The homepage usually doesn't have many complex features but instead displays basic information. Depending on the needs, you can add sections like featured articles, important links, or interesting images.",
          components: ["Search Bar", "Data Table"],
        },
        {
          title: "Detail",
          height: "60%",
          description:
            "The homepage is typically the default page displayed when users access your application. It usually contains an overview of the application or important content such as news, greetings, or brief instructions.",
          functionality:
            "The homepage usually doesn't have many complex features but instead displays basic information. Depending on the needs, you can add sections like featured articles, important links, or interesting images.",
          components: ["Search Bar", "Data Table"],
        },
        {
          title: "Data Table",
          height: "50%",
          description:
            "The homepage is typically the default page displayed when users access your application. It usually contains an overview of the application or important content such as news, greetings, or brief instructions.",
          functionality:
            "The homepage usually doesn't have many complex features but instead displays basic information. Depending on the needs, you can add sections like featured articles, important links, or interesting images.",
          components: ["Row", "Column", "Pagination"],
        },
        {
          title: "Search Bar",
          height: "30%",
          description:
            "The homepage is typically the default page displayed when users access your application. It usually contains an overview of the application or important content such as news, greetings, or brief instructions.",
          functionality:
            "The homepage usually doesn't have many complex features but instead displays basic information. Depending on the needs, you can add sections like featured articles, important links, or interesting images.",
          components: ["Title", "Textfield"],
        },
      ],
    };
  },
};
</script>

<style scoped>
/* CSS của component */
.v-carousel {
  padding: 20px;
  margin-bottom: 20px;
}

.v-card-text {
  padding: 30px;
}

.v-divider {
  margin-left: 200px;
  margin-right: 200px;
}

.fieldhelp-title {
  padding-left: 20px;
}
</style>
